export default __webpack_public_path__ + "static/media/splash-image.94534e87.jpg";